import React, { useMemo } from 'react'
import { Control, Controller } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../../ChallengeAdmin'
import { InputAdornment } from '@material-ui/core'
import YumField from '../../../../../components/YumInput/YumInput'
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage'
import { ReactComponent as DateInactiveIcon } from '../../../../../assets/v3/icons/date-inactive.svg'
import { getFieldName, getErrorMessage } from '../goalFormHelpers'

interface ConsistencyGoalFieldProps {
  control: Control<FormData>
  fieldPrefix: string
  validationRules: {
    min?: number
    max?: number
    required?: boolean
  }
  // Optional consistency unit text (e.g., "out of X days").
  // Not shown for non-individual goals (teams, countries, etc.).
  consistencyUnitText?: string
  // When true, hides the top margin (used for simple entry types like CUSTOM with simpleManualEntry or simple day types).
  hideTopMargin?: boolean
}

/**
 * Total goal (persistence goal) input field.
 * Allows users to set how many consistent days are required.
 */
export default function ConsistencyGoalField({
  control,
  fieldPrefix,
  validationRules,
  consistencyUnitText,
  hideTopMargin = false,
}: ConsistencyGoalFieldProps) {
  // Memoize InputProps to prevent input from losing focus on re-render.
  // Only show endAdornment when consistencyUnitText is provided (for individual goals).
  const inputProps = useMemo(
    () => ({
      endAdornment: consistencyUnitText ? (
        <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
          {consistencyUnitText}
        </InputAdornment>
      ) : undefined,
      // style: {
      //   background: 'white',
      // },
    }),
    [consistencyUnitText],
  )

  return (
    <Controller
      name={getFieldName('persistenceGoal', fieldPrefix) as any}
      rules={validationRules}
      control={control}
      render={({ field: { ref, ...otherField }, fieldState: { error } }) => (
        <>
          <YumField
            label={t`Total goal`}
            type="number"
            inputProps={{ inputMode: 'numeric' }}
            onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
            error={!!error}
            startIcon={DateInactiveIcon}
            InputProps={inputProps}
            style={{
              marginBottom: 0,
              //marginTop: hideTopMargin ? 0 : '12px',
            }}
            {...otherField}
            value={otherField.value ?? ''}
          />
          {error && getErrorMessage(error) && <ErrorMessage>{getErrorMessage(error)}</ErrorMessage>}
        </>
      )}
    />
  )
}
